/* eslint-disable max-len */
module.exports = i18n => ({
  text: i18n.gettext('Si necesitas más información, no dudes en'),
  link: i18n.gettext('dejarnos tu mensaje.'),
  contact: i18n.gettext('contacto'),
});
